import { Component, Input, Output, AfterViewInit, OnChanges, SimpleChanges, EventEmitter, forwardRef} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { JqueryExtensionsService } from "../../services/jquery.service";
import { Utils } from "../../Utils";

@Component({
  selector: "switch-button",
  template: `
    <div class="switch" [ngClass]="{ 'checked': _value }" [attr.title]="label">
      <input type="checkbox" [id]="id" class="switch-input" [value]="_value" [attr.checked]="_value" [attr.aria-label]="label">
      <span class="switch-label" data-on="On" data-off="Off"></span>
      <span class="switch-handle"></span>
    </div>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchButtonComponent),
      multi: true
    }]
})

export class SwitchButtonComponent implements AfterViewInit, ControlValueAccessor {
  @Input() label = 'switch';
  @Input() id: string;
  @Input('value') _value : boolean;
  @Input() disabled = false;
  @Output() onChanged: EventEmitter<boolean> = new EventEmitter<boolean>(); 
  onChange: any = () => {  };
  onTouched: any = () => { }; 
 
  //get value() {
  //  //console.log("swtichbutton get_value()")
  //  return this._value;
  //}

  //set value(val) {
  //  //this.value = !this.value;
  //  //console.log("swtichbutton set_value("+val+")")
  //  this._value = val;
  //  this.onChange();
  ////console.log("emit? :" + val);
  //  this.onTouched();
  //}

  private element: JQuery;

  constructor(private jqueryService: JqueryExtensionsService) {
    if (!this.id) { this.id = "switch-button-" + Utils.generateUUID(); }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      //console.log(`switch chagnge ${propName}  change: ${changes[propName].currentValue}`);
      if(propName === "_value")
        this.jqueryService.bootstrapSwitchChangeState("#" + this.id, changes["_value"].currentValue);
    }

    //  if (this.value && changes["state"].currentValue !== changes["state"].previousValue) {
    //    if (this.disabled) {
    //      this.jqueryService.bootstrapSwitchChangeDisabled("#" + this.id, false);
    //      this.jqueryService.bootstrapSwitchChangeState("#" + this.id, changes["state"].currentValue);
    //      this.jqueryService.bootstrapSwitchChangeDisabled("#" + this.id, this.disabled);
    //    } else {
    //      this.jqueryService.bootstrapSwitchChangeState("#" + this.id, changes["state"].currentValue);
    //    }
    //  }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  } 

  writeValue(value) {
    if (value !== undefined) {
      this._value = value;
    }
  }

  ngAfterViewInit() {
    let self = this;
    if (!this.id) { this.id = "switch-button-" + Utils.generateUUID(); }
    //console.log("switch button ngAfterViewInit() + id = " + this.id)
    setTimeout(() => {

      var toggle = (val) => { this.onChanged.emit(val); }//<-- this magic makes the call back happen!  Muhahah!
      this.element = this.jqueryService.bootstrapSwitch("#" + this.id, this._value, false);
      $("#" + this.id).on("switchChange.bootstrapSwitch", function (...args: Array<any>) {
        //self.onChanged.emit(args[1] || false);
        self._value = args[1] || false;
        self.onChange(self._value);
        toggle(self._value); 
        //console.log("switch-button ngAfterinit() onChanged emit this.value:" + this.value + "self:" + self + " self.value:" + self._value + " id:" + this.id);
        //debugger; 
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/switch-button/switch-button.component.ts